module.exports = __webpack_public_path__ + "static/media/WhitePineFullLogo.c87e2eea.svg";